import { useEffect, type RefObject } from 'react'
import { Platform, type TextInput } from 'react-native'

/**
 * Sets HTML `id` and `name` on web inputs (react-native-web does not forward `name`,
 * and `nativeID` may not reach TextInput DOM nodes).
 */
export function useWebInputName(
    inputRef: RefObject<TextInput | null>,
    nativeID: string | undefined,
    name: string | undefined,
) {
    useEffect(() => {
        if (Platform.OS !== 'web' || !name) return
        const el = inputRef.current as unknown as HTMLElement | null
        if (!el) return
        if (nativeID) {
            el.id = nativeID
        }
        el.setAttribute('name', name)
    }, [inputRef, nativeID, name])
}
